export default __webpack_public_path__ + "static/media/DS.69d068cc.png";